import { API_URL } from '../../api/client';
import { JobDetail } from '../../models/JobDetail';

const JobDetailComponent = (job: JobDetail): React.JSX.Element => {
   return (
      <>
         <h1 id="installation">Job Results: {job.job_id}</h1>
         <div className="labeled-properties">
            <div id="job-labeled-properties">
               {job.job_name && (
                  <>
                     <span className="label">Job Name:</span> {job.job_name}
                     <br />
                  </>
               )}
               {job.queries.length > 1 && (
                  <>
                     <span className="label">Number of Queries:</span> {job.queries.length}
                     <br />
                  </>
               )}
               <span className="label">Status:</span>{' '}
               <span id="job-status" className="status {{job.status}}">
                  {job.status}
               </span>
               {!job.progress?.done && job.queries.length > 2 && job.progress !== null && (
                  <progress
                     value={job.progress.ratio}
                     max="1"
                     title={`(${job.progress.processed} / ${job.progress.total})`}
                  >
                     ({job.progress.processed}&nbsp;/&nbsp;{job.progress.total})
                  </progress>
               )}
               {job.has_errors && job.queries_with_errors && (
                  <>
                     <br />
                     <span className="label">Errors:</span> {job.num_errors} &nbsp;&nbsp;(
                     <a href="#" id="toggle_error_queries_btn" title="show queries with errors">
                        queries
                     </a>
                     )
                     <div id="div_queries_with_errors" style={{ display: 'none' }}>
                        <span className="label">Queries with errors:</span>
                        <br />
                        <textarea rows={4} cols={60} id="queries_with_errors">
                           {job.queries_with_errors.join('\n')}
                        </textarea>
                     </div>
                  </>
               )}
               {job.running_time && (
                  <>
                     <br />
                     <span className="label">Running Time:</span> {job.running_time}
                  </>
               )}
            </div>
         </div>
         <div style={{ display: 'block', fontSize: '0.6rem' }}>
            {job.result_zip_url && (
               <a href={`${API_URL}/${job.result_zip_url}`}>
                  <button className="btn btn-primary">Download all&nbsp;&nbsp;(~{job.result_zip_size})</button>
               </a>
            )}
         </div>

         <br></br>
         <table id="queries-tab">
            <thead>
               <tr>
                  <th style={{ width: '2rem', minWidth: 0 }}>#</th>
                  <th style={{ width: '7rem' }}>Query</th>
                  <th colSpan={2}>Status</th>
                  <th style={{ width: '7rem' }}>Results</th>
                  <th style={{ width: '15rem' }}>Notes</th>
                  <th>&nbsp;</th>
               </tr>
            </thead>
            <tbody>
               {job.queries.map((q) => (
                  <tr key={q.idx}>
                     <td>{q.idx}</td>
                     <td>
                        <code className="query">
                           <a href={`/job/${job.job_id}/query/${q.label}`}>{q.query}</a>
                        </code>
                     </td>
                     <td className="status">
                        <span className={`status ${q.status}`}>{q.status}</span>
                     </td>
                     <td className="progr">
                        {!q.done && q.progress ? (
                           <progress
                              value={q.progress.processed}
                              max={q.progress.total}
                              title={`${q.progress.processed} / ${q.progress.total}`}
                           >
                              ({q.progress.processed}&nbsp;/&nbsp;{q.progress.total})
                           </progress>
                        ) : (
                           <div className="prod-placeholder"></div>
                        )}
                     </td>
                     <td>
                        Apo:&nbsp;{q.num_found_apo_chains}&nbsp;&nbsp;Holo:&nbsp;{q.num_found_holo_chains}{' '}
                     </td>
                     <td>
                        {q.comment && (
                           <>
                              {q.comment}
                              <br />
                           </>
                        )}
                        {q.status === 'error' && (
                           <>
                              Finished with error&nbsp;(
                              <a
                                 href={`/api/job/${job.job_id}/query/${q.label}/log`}
                                 target="_blank"
                                 style={{ textDecoration: 'underline' }}
                                 title="Go to Query processing log"
                              >
                                 see log
                              </a>
                              )
                           </>
                        )}
                     </td>
                     <td className="buttons">
                        <a href={`${job.job_id}/query/${q.label}`}>
                           <button className="btn btn-primary">Details</button>
                        </a>{' '}
                        <a href={`${API_URL}/${q.result_zip_url}`}>
                           <button className="btn btn-primary">Download</button>
                        </a>
                     </td>
                  </tr>
               ))}
            </tbody>
         </table>
      </>
   );
};

export default JobDetailComponent;
